module.exports = __webpack_public_path__ + "img/small-4.d309d3ee.webp";